import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { getPaginatedNodes } from './utils';

const GET_APPLICATIONS = graphql(`
  query getApplications {
    applications(pagination: { first: 500 }) {
      edges {
        cursor
        node {
          uuid
          name
          version
          entity {
            cursor
            node {
              uuid
              domains {
                edges {
                  cursor
                  node {
                    uuid
                    domain
                  }
                }
              }
              aliases(filters: { groupSources: true }) {
                edges {
                  cursor
                  node {
                    uuid
                    name
                    sources
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);

export function useGetApplicationsQuery() {
  const { loading, error, data } = useQuery(GET_APPLICATIONS, {});

  const { applications } = useMemo(
    () => ({
      applications: getPaginatedNodes(data?.applications),
    }),
    [data?.applications]
  );

  return {
    loading,
    error,
    data,
    applications,
  };
}
